/**
 * 申請受付　画面名記録用ファイル
 */
// tslint:disable-next-line:no-namespace
export namespace CustomScreenName {

  /** CE財団メニュー */
  export const CE_MENU: string = 'ceFoundationMenu';

  /** 建設業者情報検索 */
  export const TRADER_INFO_SEARCH: string = 'traderInfoSearch';

  /** 業者情報 */
  export const TRADER_INFO: string = 'traderInfo';

  /** 経審情報 */
  export const TRADER_INFO_WORKTYPES: string = 'traderInfoWorkTypes';
}
